<template src="./Index.html">
</template>


<script>
// import { showAlert } from "@/utils/helpers";

import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";
import ProceduresView from "./actions/Procedures.vue";
import AnalysisView from "./actions/Analysis.vue";
import PrescriptionsView from "./actions/Prescriptions.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
        ProceduresView,
        AnalysisView,
        PrescriptionsView,

  },
  created() {

    this.getReasons();
    this.getAll();
    this.$store.dispatch("lookups/getLookups");
    this.$store.dispatch("lookups/getDoctors");

  },
  computed: {

    doctors() {

      return [
        ...this.$store.state.lookups.doctors];
    },
    appointmentTypes() {
      return [
        { value: 0, label: "الكل" },
        ...this.$store.getters["lookups/getLookupByType"](
          this.$lookupTypes.AppointmentTypes
        )];
    },
    pageCount() {
      return Math.ceil(
        this.$store.state.doctorsAppointments.totalItems / this.filters.pageSize
      );
    },
    appointments() {
      return this.$store.state.doctorsAppointments.appointments;
    },

    reasons() {
      return this.$store.state.lookups.reasons;
    },
    user() {
      return this.$store.state.security.user;
    },
  },

  data() {
    return {
      permissions: this.$patientsManagementPermissions.DoctorsAppointmentsPermissions,

      dialog: false,
      dialogType: null,
      dialogMessage: "",
      formDialog: false,

      vm: {
        reasonId: null
      },
      view: 0,

      filters: {
        page: 1,
        pageSize: 10,
        appointmentTypeId: 0,
        fullName: null,
        doctorId: 1,
        phoneNo: null,
        date: null,
        // date: new Date().toISOString().split('T')[0]
      },
      headers: [
        { text: 'نوع الحجز ', value: 'appointmentType' },
        { text: 'رقم الملف', value: 'fileNo' },
        { text: 'اسم الحالة', value: 'fullName' },
        { text: 'تاريخ الموعد', value: 'appointmentDate' },
        { text: "وقت تأكيد الحضور ", value: "acceptedTime", sortable: false },
        // { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ الاعتماد", value: "approvedOn", sortable: false },
        { text: 'الحالة', value: 'status', sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      itemId: 0,
    };
  },
  methods: {
    changeDoctor() {
      this.getReasons();
      this.getAll();
    },
    getAll(page) {
      // if (this.user.userTypeId == 1002 && this.filters.doctorId == null) {
      //   showAlert(`الرجاء اختيار الطبيب`);
      //   return false;
      // }
      this.filters.page = page || 1;
      this.$store.dispatch("doctorsAppointments/getAll", this.filters);

    },
    getReasons() {
      this.$store.dispatch("lookups/getReasons", this.filters.doctorId);


    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
      ProceduresView(item) {
      this.itemId = item.id;
      this.view = 4;
      // Implement view logic
    },   
        AnalysisView(item) {
      this.itemId = item.id;
      this.view = 5;
      // Implement view logic
    },  
      PrescriptionsView(item) {
      this.itemId = item.id;
      this.view = 6;
      // Implement view logic
    }, 
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    deleteItem(item) {
      this.itemId = item.id;
      this.$store.dispatch(`patients/delete`, this.itemId);
    },
    back() {
      this.view = 0;
    },
    // ----------------------------------------------------------
    // --------------------------form dilog ------------------------------- //
    reviewItem(item) {
      this.itemId = item.id;
      this.formDialog = true;

    },
    confirmFormDialog() {
      if (this.vm.reasonId == null) {
        return false;
      }
      let vm = {
        reasonId: this.vm.reasonId,
        doctorId: this.filters.doctorId
      }
      this.$store
        .dispatch("doctorsAppointments/review", {
          id: this.itemId,
          payload: vm
        })
        .then(() => {
          this.cancelFormDialog()
        })
        .catch(() => { });

    },
    cancelFormDialog() {
      this.formDialog = false;
      this.vm = {
        reasonId: null,
      };
      this.$refs.reason.reset(); // إعادة تعيين الحقول والتحقق

    },
    // // -------------- end empDialog  -----
    showDialog(item, type) {
      switch (type) {
        case "followUp":
          this.dialogMessage = "هل انت متأكد من رغبتك اضافة اجراء المتابعة للمريض ";
          break; 
          case "unfollowUp":
          this.dialogMessage = "هل انت متأكد من رغبتك الغاء اجراء المتابعة للمريض ";
          break;
        case "approval":
          this.dialogMessage = "هل انت متأكد من رغبتك تأكيد الحضور";
          break;
  case "servicesApproval":
          this.dialogMessage = "هل انت متأكد من رغبتك تأكيد الخدمات و انشاء فاتورة";
          break;

      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`doctorsAppointments/${this.dialogType}`, {
        id: this.itemId,
        doctorId: this.filters.doctorId
      });
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    handleClear() {
      this.filters.date = null;
    },
  },
};
</script>

<style scoped></style>